import React from 'react';

// Chunk que nao carregou (ChunkLoadError do webpack, JS ou CSS). Devolve a URL do arquivo.
function urlDoChunk(erro) {
    if (!erro) return null;
    const msg = erro.message || '';
    if (erro.name !== 'ChunkLoadError' && !/Loading (CSS )?chunk \S+ failed/i.test(msg)) return null;
    return erro.request || (msg.match(/\(error: ([^)\s]+)\)/) || [])[1] || null;
}

// Isola falhas de um modulo personalizado: se o componente quebrar no render,
// mostra um card de erro e o RESTO da Central segue funcionando (nao tela branca).
//
// Chunk que nao carregou costuma ser cache ruim, nao a tela: um 404 pego no meio de um
// deploy fica guardado como `immutable` e F5 nao resolve (29/09/2026). Nesse caso baixa
// o arquivo de novo ignorando o cache e recarrega a pagina UMA vez por arquivo na sessao.
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { erro: null, curando: false };
    }

    static getDerivedStateFromError(erro) {
        return { erro };
    }

    componentDidCatch(erro, info) {
        console.error('[personalizado] erro isolado:', erro, info);
        const url = urlDoChunk(erro);
        if (!url) return;
        const chave = `centralbabita.cura-chunk:${url}`;
        try {
            if (sessionStorage.getItem(chave)) return;
            sessionStorage.setItem(chave, '1');
        } catch (e) {
            return;
        }
        this.setState({ curando: true });
        fetch(url, { cache: 'reload' })
            .catch(() => {})
            .finally(() => window.location.reload());
    }

    render() {
        if (this.state.curando) {
            return (
                <div className="page">
                    <div className="page-head">
                        <div>
                            <div className="eyebrow"><span className="num">↻</span> Personalizado</div>
                            <h1 className="page-title">Atualizando a tela…</h1>
                            <p className="page-sub">Esta tela foi atualizada. Buscando a versão nova.</p>
                        </div>
                    </div>
                </div>
            );
        }
        if (this.state.erro) {
            const msg = (this.state.erro && this.state.erro.message) || String(this.state.erro);
            return (
                <div className="page">
                    <div className="page-head">
                        <div>
                            <div className="eyebrow"><span className="num">!</span> Personalizado</div>
                            <h1 className="page-title">{this.props.titulo || 'Tela personalizada'} indisponivel</h1>
                            <p className="page-sub">Esta tela personalizada apresentou um erro e foi isolada. O restante da Central continua funcionando normalmente.</p>
                        </div>
                    </div>
                    <div className="card">
                        <p className="muted" style={{ fontFamily: 'monospace', fontSize: 12, whiteSpace: 'pre-wrap' }}>{msg}</p>
                        <button className="btn sm" style={{ marginTop: 12 }} onClick={() => this.setState({ erro: null })}>
                            Tentar novamente
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
